import { render, staticRenderFns } from "./CreateForTeam.vue?vue&type=template&id=2fbb2c83&scoped=true&"
import script from "./CreateForTeam.vue?vue&type=script&lang=ts&"
export * from "./CreateForTeam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbb2c83",
  null
  
)

export default component.exports